"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuRenderer = menuRenderer;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "modal": "RequestAccessModal__modal__21GSg",
  "header": "RequestAccessModal__header__176tA",
  "body": "RequestAccessModal__body__2IZsi",
  "footer": "RequestAccessModal__footer__146cz",
  "title": "RequestAccessModal__title__2-WYg",
  "sla-details": "RequestAccessModal__sla-details__2qE2W",
  "slaDetails": "RequestAccessModal__sla-details__2qE2W",
  "sla-tier-limits": "RequestAccessModal__sla-tier-limits__1R6k4",
  "slaTierLimits": "RequestAccessModal__sla-tier-limits__1R6k4",
  "errors": "RequestAccessModal__errors__1VSon",
  "group-title": "RequestAccessModal__group-title__3iBfs",
  "groupTitle": "RequestAccessModal__group-title__3iBfs"
};
/*
 * This is the modified version of anypoint-components 'defaultMenuRenderer' function
 * (https://github.com/mulesoft/anypoint-components/blob/master/src/components/Select/utils/defaultMenuRenderer.js)
 */

require('./RequestAccessModal.css');
function groupByEnvironment(arr) {
  return arr.reduce(function (acc, curr) {
    var groupId = curr.environmentName || curr.environmentId;
    var currentGroupValues = acc[groupId] || [];
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, groupId, [].concat((0, _toConsumableArray2.default)(currentGroupValues), [curr])));
  }, {});
}
function sortBy(key) {
  return function (a, b) {
    return a[key].localeCompare(b[key]);
  };
}
function isOptionSelected(valueArray, option) {
  if (valueArray && valueArray.length === 1) {
    return valueArray[0].value === option.value;
  }
  return false;
}
function menuRenderer(_ref) {
  var focusedOption = _ref.focusedOption,
    instancePrefix = _ref.instancePrefix,
    onFocus = _ref.onFocus,
    onSelect = _ref.onSelect,
    optionClassName = _ref.optionClassName,
    Option = _ref.optionComponent,
    optionRenderer = _ref.optionRenderer,
    options = _ref.options,
    valueArray = _ref.valueArray,
    valueKey = _ref.valueKey,
    onOptionRef = _ref.onOptionRef,
    testId = _ref.testId,
    theme = _ref.theme;
  var groupedOptions = groupByEnvironment(options);
  var isSelectClass = theme['is-selected'];
  var isFocusedClass = theme['is-focused'];
  var environments = Object.keys(groupedOptions).sort();
  return environments.map(function (environment) {
    var instances = groupedOptions[environment].sort(sortBy('label'));
    var optionsList = instances.map(function (option, i) {
      var isFocused = option === focusedOption;
      var isSelected = isOptionSelected(valueArray, option);
      var optionClass = (0, _classnames.default)(optionClassName, theme['select-option'], (0, _defineProperty2.default)((0, _defineProperty2.default)({}, isSelectClass, isSelected), isFocusedClass, isFocused));
      return /*#__PURE__*/_react.default.createElement(Option, {
        className: optionClass,
        instancePrefix: instancePrefix,
        isDisabled: option.disabled,
        isFocused: isFocused,
        isSelected: isSelected
        /* eslint-disable-next-line react/no-array-index-key */,
        key: "option-".concat(i, "-").concat(option[valueKey]),
        onFocus: onFocus,
        onSelect: onSelect,
        option: option,
        optionIndex: i,
        testId: testId && "".concat(testId, "-menu-option"),
        ref: function ref(_ref2) {
          return onOptionRef(_ref2, isFocused);
        }
      }, optionRenderer(option, i));
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      key: environment
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(optionClassName, theme['select-option'], styles.groupTitle)
    }, environment), optionsList);
  });
}
//# sourceMappingURL=utils.js.map